// import 'antd/dist/antd.css';
import 'antd/dist/reset.css';

import 'react-base-table/styles.css';
import 'nprogress/nprogress.css';
import 'react-placeholder/lib/reactPlaceholder.css';
import './global.css';
